export default __webpack_public_path__ + "form-section-v2.png";